module.exports = __webpack_public_path__ + "static/media/integration-diagram.c356b58c.png";